import { useState, type ReactNode } from 'react';
import { TravelCalendarConfirm } from '../../shared/travel_calendar_confirm.js';
import { HotelDateCalendar, exceedsMaxStay, type HotelDateRange } from './hotel_date_calendar.js';
import type { HotelSearchCopy } from './hotel_search_bar.js';

/**
 * O calendário com o RASCUNHO do intervalo. O rascunho só existe enquanto o
 * painel está em cena (a confirmação o entrega ao `value` do host) e nasce a
 * cada abertura a partir do valor confirmado — é o que faz "abrir, mexer e
 * desistir" voltar ao intervalo que a busca realmente tem. Monta com o painel,
 * então o `useState` inicial É a abertura.
 */
export function StayCalendar({
  copy,
  initial,
  months,
  layout,
  searches,
  onConfirm,
}: {
  readonly copy: HotelSearchCopy;
  readonly initial: HotelDateRange;
  readonly months: 1 | 2;
  readonly layout?: 'popover' | 'sheet';
  /** O Confirmar também busca com este rascunho: o rótulo diz ("Confirmar e
   *  buscar"). */
  readonly searches?: (draft: HotelDateRange) => boolean;
  readonly onConfirm: (dates: HotelDateRange) => void;
}): ReactNode {
  const [draft, setDraft] = useState<HotelDateRange>(initial);
  return (
    <HotelDateCalendar
      value={draft}
      locale={copy.calendarLocale}
      previousMonthLabel={copy.previousMonthLabel}
      nextMonthLabel={copy.nextMonthLabel}
      months={months}
      {...(layout ? { layout } : {})}
      onChange={setDraft}
      footer={
        <TravelCalendarConfirm
          summary={copy.dateDraftSummary(draft)}
          confirmLabel={confirmLabel(copy, draft, layout, searches?.(draft) ?? false)}
          disabled={!draft.checkin || !draft.checkout || exceedsMaxStay(draft, copy.maxStayNights)}
          full={layout === 'sheet' || months === 1}
          onConfirm={() => {
            onConfirm(draft);
          }}
        />
      }
    />
  );
}

function confirmLabel(
  copy: HotelSearchCopy,
  draft: HotelDateRange,
  layout: 'popover' | 'sheet' | undefined,
  searches: boolean,
): string {
  if (searches) return copy.confirmAndSearchLabel;
  return layout === 'sheet' ? copy.confirmDatesSheetLabel : copy.confirmDatesLabel(draft);
}
